// filters components
export const filtersText = {
  selectDateRange: 'Sélectionnez une plage de dates',
  apply: 'Appliquer',
  cancel: 'Annuler',
};

export const StatsCardText = {
  revenueHeader: "Chiffre d'affaire",
  regularizeTransactions: 'Transactions à régulariser :',

  errortitle: 'Erreur',
  errorLoading: 'Erreur de chargement',
  creditClient: 'Credit client',
};

export const filtersParams = {
  PageSize: '20',
  Page: '0',
  SortBy: 'date_added',
  SortOrder: 'desc',
};
